import { render, staticRenderFns } from "./member-password.vue?vue&type=template&id=459bdfa2&"
import script from "./member-password.vue?vue&type=script&lang=js&"
export * from "./member-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports